module.exports = __webpack_public_path__ + "img/sec-behind.b884b668.svg";